import axios from '@/clientAPI.ts'
import {HostPartialSchema} from '@/features/authentication/services/auth.schema'
import {HostPartialType, HostTypeV3} from '@/features/authentication/types'
import * as types from '../types'
import {SavedHostResponseSchema} from './guest.schema'
import axiosV3 from '@/clientAPIV3.ts'

export const GUEST_API = {
    saveHost: async ({hostId}: {hostId: number}): Promise<HostPartialType> => {
        const url = `/rookies/${hostId}/save`
        const {data} = await axios.post(url)
        return HostPartialSchema.parse(data)
    },
    unsaveHost: async ({hostId}: {hostId: number}): Promise<HostPartialType> => {
        const url = `/rookies/${hostId}/save`
        const {data} = await axios.delete(url)
        return HostPartialSchema.parse(data)
    },
    getSavedHosts: async (): Promise<HostPartialType[]> => {
        const url = `/rookies/saved`
        const {data} = await axios.get(url)
        return SavedHostResponseSchema.parse(data)
    },
    getMinMaxAge: async (): Promise<types.AgesType> => {
        const {data} = await axios.get(`/filters/ages`)
        return data
    }
}

export const getCreatorProfile = async (creatorIdentifier: string): Promise<HostTypeV3> => {
    const {data} = await axiosV3.get(`/creators/${creatorIdentifier}`)
    return data
}

export const getSubscriptionsToRenewV3 = async (): Promise<types.SubscriptionsV3> => {
    const response = await axiosV3.get('/subscriptions/renew')
    return response.data
}

export const getSubscriptionsToRenewCreditCardV3 = async (): Promise<types.SubscriptionsToRenewCreditCardV3> => {
    const response = await axiosV3.get('/subscriptions/renew/credit-card')
    return response.data
}

export const renewSubscriptionV3 = async (body: types.SubscriptionsUpdateV3) => {
    const response = await axiosV3.post('/subscriptions/renew', body)
    return response.data
}
